module.exports = __webpack_public_path__ + "img/bg-kompack-register.5a2a6c7c.svg";